import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {Button, Form, Input, Select} from "antd";
import RequestTypeSelectBox from "../request-type/RequestTypeSelectBox";
import ReportEditor from "../../core/components/ReportEditor";
import ModalitySelectBox from "../modality/ModalitySelectBox";
import ApiService from "../../core/service/api-service";
import {Pages} from "../../AppRouter";
import StudyTypeEnum from "../../enums/StudyTypeEnum";

const defaultReportContent = {
    Teknik: '',
    Karsilastirma: '',
    SonucVeOneriler: '',
    Bulgular: ''
}

export default function ReportTemplateCreateEditForm({reportTemplateId})
{
    const {t} = useTranslation()
    const formRef = useRef();

    const [defaultTemplateContent, setDefaultTemplateContent] = useState(defaultReportContent);
    const [selectedModalityId, setSelectedModalityId] = useState(-1);
    const [templateId, setTemplateId] = useState(reportTemplateId || null);
    const template = useRef({})

    const getReportTemplate = async () => {
        if(templateId && templateId > 0)
        {
            const templateResponse = await ApiService.ReportTemplate.Get(templateId);
            if(templateResponse.success)
            {
                formRef.current.setFieldsValue({
                    name: templateResponse.data.name,
                    modalityId: templateResponse.data.requestType.modality.name,
                    requestTypeId: templateResponse.data.requestType.name,
                    language: templateResponse.data.language,
                    studyType: templateResponse.data.studyType,
                })

                await getReportTemplateFileData()
            }
        }
    }

    const getReportTemplateFileData = async () => {
        const tempFileResponse = await ApiService.ReportTemplate.GetReportTemplateFileData(templateId);
        setDefaultTemplateContent(JSON.parse(tempFileResponse.data))
        template.current = JSON.parse(tempFileResponse.data)
    }

    const save = async (form) => {
        const data = {
            ...form,
            content: template.current,
        };

        if(templateId)
        {
            const response = await ApiService.ReportTemplate.Edit(templateId, data);
        }
        else
        {
            const response = await ApiService.ReportTemplate.Create(data);
            if(response.success)
            {
                setTemplateId(response.data)
            }
        }
    }

    useEffect(() => {
        getReportTemplate()
    }, [templateId])

    useEffect(() => {
        setTemplateId(reportTemplateId)
    }, [reportTemplateId]);

    return (
        <>
            <Form
                ref={formRef}
                name="basic"
                layout={'vertical'}
                onFinish={save}
                autoComplete="off"
            >
                <Form.Item
                    label={t('Name')}
                    name="name"
                    rules={[{ required: true, message: t('Please input report template name!') }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label={t('Language')}
                    name="language"
                    rules={[{ required: false }]}
                >
                    <Select placeholder={t('Select Language')} allowClear>
                        <Select.Option value="tr">Türkçe</Select.Option>
                        <Select.Option value="en">English</Select.Option>
                        <Select.Option value="de">Deutsch</Select.Option>
                        <Select.Option value="fr">Français</Select.Option>
                        <Select.Option value="es">Español</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item name="modalityId" label={t('Modality')} rules={[{ required: true }]}>
                    <ModalitySelectBox
                        disabled={templateId}
                        mode={'single'}
                        onChange={(modalityId) => {
                            setSelectedModalityId(modalityId)
                            formRef.current.setFieldsValue({
                                requestTypeId: null
                            })
                        }}
                        filterOption={(input, option) => {
                            return option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }}
                        showSearch={true}
                    />
                </Form.Item>

                <Form.Item name="requestTypeId" label={t('Request Type')} rules={[{ required: true }]}>
                    <RequestTypeSelectBox
                        disabled={templateId}
                        modalityId={selectedModalityId}
                        onChange={(requestId) => {

                        }}
                    />
                </Form.Item>

                <Form.Item name="studyType" label={t('Study Type')} rules={[{ required: false }]}>
                    <Select placeholder={t('Select Study Type')} allowClear>
                        <Select.Option value={StudyTypeEnum.ROUTINE}>{t('Routine')}</Select.Option>
                        <Select.Option value={StudyTypeEnum.INPATIENT}>{t('Inpatient')}</Select.Option>
                        <Select.Option value={StudyTypeEnum.EMERGENCY}>{t('Emergency')}</Select.Option>
                        <Select.Option value={StudyTypeEnum.COMPARATIVE_EXAMINATION}>{t('Comparative Examination')}</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item>
                    <ReportEditor
                        editable={templateId}
                        defaultReportContent={defaultTemplateContent}
                        onBulgular={(data) => {
                            template.current = {
                                ...template.current,
                                Bulgular: data
                            }
                        }}
                        onSonuc={(data) => {
                            template.current = {
                                ...template.current,
                                SonucVeOneriler: data
                            }
                        }}
                        onKarsilastirma={(data) => {
                            template.current = {
                                ...template.current,
                                Karsilastirma: data
                            }
                        }}
                        onTeknik={(data) => {
                            template.current = {
                                ...template.current,
                                Teknik: data
                            }
                        }}
                    />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t('Save')}
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
